import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import EditorViewer from '@/_components/editorJS/viewer/viewer.vue'

@Component({
    components: { EditorViewer },
    mixins: [],
})
export default class Contact extends Mixins<MixinInterface>() {
    @Prop({ required: true }) id!: string

    get contact() {
        return this.$store.getters.hseContact(this.id)
    }
}
